import React, {useContext, useState} from "react";
import {SignInContext} from "../../../../context/SignInContext";
import {ConversationRepository} from "../../../../repositories/ConversationRepository";
import {Box, IconButton, Input, Slide, Stack, Typography} from "@mui/material";
import {AgentAnimation} from "../../../../components/lottie-animations/AgentAnimation";
import {HugeiconsIcon} from "@hugeicons/react";
import {SendIcon} from "@hugeicons/core-free-icons";
import {useNavigate} from "react-router-dom";


export const CreateConversation = ({project, conversationType= "CHAT_BOT"}) => {
  const [showAnimation, setShowAnimation] = useState(true);
  const [message, setMessage] = useState("");
  const {currentUser} = useContext(SignInContext);
  const navigate = useNavigate();


  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!message) {
      return;
    }
    const username = currentUser?.username;
    const senderLS = localStorage.getItem("sender");
    const sender = senderLS || (project?.vdnManager ? project?.vdnManager[username] || -999 : -999);

    ConversationRepository.createConversation({
      flowUid: project?.id,
      sender: sender,
      message: message,
      type: conversationType
    })
      .then((response) => {
        setShowAnimation(false);
        setMessage("");
        setTimeout(() => {
          navigate(`/project/${project?.id}/supervision/${response?.data?.id || ""}`);
        }, 730)
      })
      .catch(error => {
        console.log(error)
      })
  }

  return (
    <>
      <Slide in={showAnimation} direction={"down"} timeout={600}>
        <Box sx={{my: "auto"}}>
          <AgentAnimation open width={320} height={400} loop={false}/>
          <Typography
            variant="h4" align="center" color="primary"
            sx={{
              // fontFamily: "'Raleway', sans-serif",
              fontSize: "1.4rem",
              fontWeight: 600,
              letterSpacing: 1,
              mt: 2,
            }}
          >
            Start testing — your virtual agent is ready
          </Typography>
        </Box>
      </Slide>
      <Slide in={showAnimation} direction={"up"} timeout={700}>
        <Stack component={"form"} onSubmit={handleSubmit} maxWidth={"sm"} direction={"row"} gap={2}
               className={"border-shadow"} sx={{p: 2, borderRadius: 5, width: "90%", mb: 5}}>
          <Input
            placeholder={"Enter your message here"} disableUnderline
            sx={{flex: 1}} maxRows={3} multiline
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault(); // prevent newline
                handleSubmit(e);    // manually submit
              }
            }}
          />
          <Box>
            <IconButton type={"submit"}><HugeiconsIcon icon={SendIcon}/></IconButton>
          </Box>
        </Stack>
      </Slide>
    </>
  )
}
